import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
import { rootReducer } from './reducer';
import purgeMiddleware from './middleware/purgeMiddleware';
import {
  bootstrapTabSession,
  installTabCloseLogoutHandlers,
} from './utils/tabCloseLogout';

bootstrapTabSession();
installTabCloseLogoutHandlers();

const createPersistStorage = () => {
  if (typeof window === 'undefined') {
    return {
      getItem: async () => null,
      setItem: async () => undefined,
      removeItem: async () => undefined,
    };
  }
  return createWebStorage('session');
};

const persistConfig = {
    key: 'root',
    storage: createPersistStorage(),
    whitelist: ['auth'],
    throttle: 0,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(purgeMiddleware),

})

export const persistor = persistStore(store)
